export const titleAnimation = {
  initial: {
    opacity: 0,
  },
  opacityIn: {
    opacity: 1,
    transition: {
      duration: 0.47,
      delay: 0.17,
      ease: 'linear',
    },
  },
}
export const lineAnimation = {
  initial: {
    opacity: 0,
    x: -260,
  },
  transformIn: {
    x: 0,
    transition: {
      duration: 1.9,
      ease: 'easeInOut',
    },
  },
  opacityIn: {
    opacity: 1,
    transition: {
      duration: 0.63,
      ease: 'linear',
    },
  },
}
export const wrapperAnimation = {
  opacityIn: {
    transition: {
      staggerChildren: 0.43,
      delay: 0.13,
    },
  },
  transformIn: {
    transition: {
      staggerChildren: 0.43,
      delay: 0.13,
    },
  },
}
export const slideImageAnimation = {
  initial: {
    opacity: 0,
    x: 300,
  },

  opacityIn: {
    opacity: 1,
    transition: {
      duration: 0.67,
      ease: 'linear',
    },
  },

  transformIn: {
    x: 0,
    transition: {
      duration: 1.87,
      ease: 'easeOut',
    },
  },
}
